module.exports = __webpack_public_path__ + "static/img/alipay-tip.8bb02361.png";